import { render, staticRenderFns } from "./SelectCandidate.vue?vue&type=template&id=1fce97df&"
import script from "./SelectCandidate.vue?vue&type=script&lang=js&"
export * from "./SelectCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports